App.namespace.wrap('es6.shared.tags_autocomplete', function (options = {}) {
  const tagsStorage = App.es6.shared.tags_storage();

  const ERROR_MESSAGES = {
    field_empty: 'Please enter an event type',
    select: 'Please select an event type from the list',
    not_recognized: 'We don\'t recognise that event type, try describing it differently'
  }

  const {
    onSelectCallback,
    onBlurAndChangeCallback,
    setErrorCallback,
    validateOnSubmit,
    initialTagSlug, // after getting tags select this tag
    onSearchComplete,
  } = options;

  const $form = options.form;
  const $tagInput = $form.find('input[name=room_tag_autocomplete]');
  const $tagSlug = $form.find('input[name=room_tag]');
  const $errorField = $form.find('.js-room-tag-error-msg')

  let hasError = false;

  // save previous query value to track unknown events
  let previousEmptyQuery = null;

  // track unknown query search after period of time
  let previousEmptyQueryDeffer;

  // track unknown query search after period of time
  let trackedEmptyQuery = null;

  /**
   * Get chosen tag slug
   */
  const getChosenTag = () => {
    const value = $tagSlug.val();

    const searchedText = $tagInput.devbridgeAutocomplete().currentValue.trim().toLowerCase();
    if (!value && (window.googleAutoCompleteForceRoomTag || (!window.__TGV_ROOM_TAG && !searchedText))) {
      return 'event-venue';
    }

    return value;
  }

  /**
   * Set chosen tag slug
   *
   * @param {string} key - tag slug
   */
  const setChosenTag = (key) => {
    $tagSlug.val(key);
  }

  const setPrettyTag = (key) => {
    $tagInput.val(key);
  }

  /**
   * On form submit, check if event type has been selected
   *
   * @param event - form submit event
   */
  const validateForm = (event) => {
    if (!getChosenTag()) {
      if (event) {
          event.preventDefault();
      }
      setError(true);
      return false
    }
    return true
  }

  /**
   * Custom lookup function for Autocomplete plugin
   *
   * It is looking for a given query in
   *
   * @param {array} tags - array of tag objects
   * @param {string} query - phrase entered by user
   * @param {function} resultsCallback - function to call with suggestions array
   */
  const lookupFunction = (tags, query, resultsCallback) => {
    const queryLowerCase = query.trim().toLowerCase();
    const getQueryIndex = tag => tag.value.toLowerCase().indexOf(queryLowerCase);
    const suggestions = tags
      .filter(tag => getQueryIndex(tag) > -1) // Get only tags matching the query
      .sort((a, b) => {
        // Tags with the query at the beginning come first
        const indexA = getQueryIndex(a);
        const indexB = getQueryIndex(b);
        if (indexA === 0 && indexB !== 0 ) {
          return -1;
        }
        if (indexA !== 0 && indexB === 0) {
          return 1;
        }
        // Withing groups (query at the beginning or not) sort results alphabetically
        if ((indexA === 0 && indexB === 0) || (indexA !== 0 && indexB !== 0)) {
          return a.value.localeCompare(b.value)
        }
        return 0;
      })


    try {
      // handle backspace and removing current string
      if (previousEmptyQuery &&
        (!query || query.indexOf(previousEmptyQuery) !== 0)
        && (!trackedEmptyQuery || trackedEmptyQuery.indexOf(query) !== 0)) {
        previousEmptyQuery = null;
      }

      // handle inactivity
      if (suggestions.length === 0) {
        previousEmptyQuery = query;
        clearTimeout(previousEmptyQueryDeffer);
        previousEmptyQueryDeffer = setTimeout(() => {
          if (trackedEmptyQuery && trackedEmptyQuery.indexOf(query) === 0) {
            return;
          }
          previousEmptyQuery = null;
        }, 1500);
      }
    } catch (err) {
      window.Rollbar.warning('Couldn\'t track suggestion', err);
    }

    resultsCallback({ suggestions });
  }

  /**
   * Function called by Autocomplete plugin, after a tag is selected from the dropdown list
   *
   * @param {object} suggestion - selected tag
   */
  const onSelectHandler = (suggestion) => {
    const key = suggestion.data.key;
    const value = suggestion.value;
    setError(false)
    setChosenTag(key);
    if (typeof onSelectCallback === 'function') {
      onSelectCallback({ key, value });
    }
  }

  const textEscape = (data) => {
    const div = document.createElement('div');
    div.innerText = data;
    return div.innerHTML;
  };

  /**
   * Handle behaviour after user clicks outside the event type field (and it looses focus)
   *
   * There are five cases:
   * 0) Event type selected properly
   * 1) Event type field is empty
   * 2) Something is entered and it matches one suggestion exactly (eg. "wedding")
   * 3) Something is entered and there are suggestions available (eg. "event")
   * 4) Something is entered and there are no suggestions (eg. "seminarrrr")
   */
  const handleTagInputBlur = ({ tags }) => {
    $tagInput.val($tagInput.val().trim());

    // Case 0
    // Event type selected properly
    const currentSelection = $tagInput.devbridgeAutocomplete().selection;
    if (currentSelection) {
      return;
    }

    const currentInputValue = $tagInput.devbridgeAutocomplete().currentValue.trim().toLowerCase();

    // Case 1
    // Event type field is empty
    if (!currentInputValue) {
      setChosenTag(null);
      if (window.__TGV_ROOM_TAG) {
        setError(true, ERROR_MESSAGES.field_empty);
      }
      return;
    }

    // Case 2
    // Something is entered and it matches one suggestion exactly (eg. "wedding")
    const matchingTags = tags.filter(tag => tag.value.toLowerCase() === currentInputValue)
    if (matchingTags.length > 0) {
      const key = matchingTags[0].data.key;
      setChosenTag(key);
      setPrettyTag(matchingTags[0].value);
      setError(false);
      if (typeof onBlurAndChangeCallback === 'function') {
        onBlurAndChangeCallback({ key });
      }
      return;
    }

    // Case 3 & 4
    const suggestions = $tagInput.devbridgeAutocomplete().suggestions;
    if (suggestions.length > 0) {
      // Something is entered and there are suggestions available (eg. "event")
      setChosenTag(null);
      setError(true, ERROR_MESSAGES.select);
    } else {
      // Something is entered and there are no suggestions (eg. "seminarrrr")
      setChosenTag(null);
      setError(true, ERROR_MESSAGES.not_recognized);
    }

    return true;
  }

  const bindEvents = () => {
    // On form submit, check if event type has been selected
    if (validateOnSubmit) {
      $form.on('submit', validateForm);
    }

    // Clear all errors after key down
    $tagInput.on('keydown', () => {
      setError(false)
    });
  }

  /* ===========================================================================================
   * PUBLIC FUNCTIONS
   * =========================================================================================== */

  /**
   * Add or remove error class from parent of the input,
   * change error message if needed,
   * call setErrorCallback function if provided.
   *
   * @param {boolean} enabled - show or hide error
   * @param {string} msg - (optional) error message text
   */
  const setError = (enabled, msg = null) => {
    hasError = enabled;
    if (enabled) {
      $tagInput.parent().addClass('has-error');
      if (msg) {
        $errorField.text(msg)
      }
    } else {
      $tagInput.parent().removeClass('has-error');
    }
    if (typeof setErrorCallback === 'function') {
      setErrorCallback(enabled, msg, $tagInput.val());
    }
  }

  const api = {
    validateIsEmpty() {
      const currentInputValue = $tagInput.autocomplete().selection;

      if (!currentInputValue && !getChosenTag()) {
        setChosenTag(null);
        setError(true, ERROR_MESSAGES.field_empty);
      }
    },
    isValid() {
      return getChosenTag().length > 0;
    },
    getTags() {
      return $tagInput.data('tags');
    },
    setBySlug(slug) {
      const tags = $tagInput.data('tags');
      const tag = tags.filter(el => el.data.key === slug)[0];

      if (tag) {
        setChosenTag(slug);
        setPrettyTag(tag.value);
        return tag;
      }

      throw new Error(`Tried to set invalid slug: ${slug}`);
    },
  };

  /**
   * Initialize Autocomplete plugin and add blur event listener to the field
   *
   * @param {array} tags - array of tag objects
   * @param callback
   */
  const initAutocomplete = ({ tags }, callback) => {
    $tagInput.devbridgeAutocomplete({
      autoSelectFirst: true,
      triggerSelectOnValidInput: false,
      showNoSuggestionNotice: true,
      minChars: 1,
      noSuggestionNotice: `<span>${ERROR_MESSAGES.not_recognized}</span>`,
      onSearchComplete(text, results) {
        if (typeof onSearchComplete === 'function') {
          onSearchComplete(text, results);
        }
      },
      lookup: lookupFunction.bind(null, tags),
      formatResult(suggestion, query) {
        const text = textEscape(suggestion.value);

        return text.replace(new RegExp(`(${query.trim()})`, 'gi'), '<strong>$1</strong>');
      },
      onSelect: onSelectHandler,
      appendTo: options.appendTo,
    });

    $tagInput.data('tags', tags);

    // Detect changes in selected tag after field lost focus
    $tagInput.on('blur', () => setTimeout(() => handleTagInputBlur({ tags }), 100));

    // @fixes https://github.com/devbridge/jQuery-Autocomplete/issues/753
    $(document).on('mousedown', '.autocomplete-suggestion', e => {
      try {
        $(e.target).click();
      } catch (error) {
        // Translates to "property value is undefined" in all browsers. Different browsers have different wording.
        if (['propert', 'value', 'undefined'].every(keyword => error.message.includes(keyword))) {
          // Ignore those specific errors.
        } else {
          throw error;
        }
      }
    });

    if (initialTagSlug && callback) {
      const tag = api.setBySlug(initialTagSlug);
      callback(tag);
    }
  };

  const init = (callback) => {
    bindEvents();

    tagsStorage.getTags()
      .then((res) => initAutocomplete(res, callback));

    return api;
  }

  return {
    init,
    setError,
  }
});
